export { default } from './BancoDoAuto25Banner';
